module.exports = __webpack_public_path__ + "img/transfer.837a5187.png";